<script setup lang="ts">
import { useElementSize } from '@vueuse/core'
import changesInShareholding from './components/changesInShareholding.vue'

definePage({
  name: 'HK-stock',
  meta: {
    title: '港股',
  },
})
const refsList = useTemplateRef('refsList') as any
const refsPageLayout = useTemplateRef('refsPageLayout')
const refTabConten = useTemplateRef('refTabConten')
const { height: tabContenHeight } = useElementSize(refTabConten, undefined, { box: 'border-box' })
const active = ref(0)

const navbarHeight = computed(() => {
  return `${refsPageLayout.value?.navbarHeight || 0}px`
})

const tabsList = ref([
  {
    name: '每日沽空',
    val: 0,
  },
  {
    name: '空头头寸',
    val: 1,
  },
])

const components: any = {
  0: changesInShareholding,
  1: changesInShareholding,
}

function onTabChange() {
  nextTick(() => {
    if (refsList.value) {
      refsList.value.reLoad()
    }
  })
}
</script>

<template>
  <FmPageLayout ref="refsPageLayout" navbar back class="fluctuation-page">
    <template #navbar-end>
      <FmIcon name="material-symbols:help-outline-rounded" class="text-22px color-[#fff]" />
      <FmIcon name="ri:share-forward-box-line" class="m-l-16px text-22px color-[#fff]" />
    </template>
    <div ref="refTabConten" class="tab-conten" :style="{ top: navbarHeight }">
      <Notice />
      <van-tabs v-model:active="active" line-width="9px" @change="onTabChange">
        <van-tab v-for="item in tabsList" :key="item.val" :title="item.name" />
      </van-tabs>
    </div>
    <div :style="{ height: `${tabContenHeight}px` }" />
    <component :is="components[active]" ref="refsList" />
  </FmPageLayout>
</template>

<style lang="scss" scoped>
.fluctuation-page {
  :deep(.van-tabs__nav) {
    background-color: #f1f2f7;
  }

  :deep(.van-tab--active) {
    font-size: 17px;
  }

  .tab-conten {
    position: fixed;
    left: 0;
    z-index: 2;
    width: 100%;
  }
}
</style>
